export const adUnitIds = {
    rewardedVideo: 242,
    interstitial: 246,
    offerwall: 240,
    banner: 247,
    all: 'all'
};

export const adUnitsMap = {
    [adUnitIds.all]: {
        name: 'overview',
        key: 'all',
        icon: 'previewSumIcon',
        displayName: 'Overview'
    },
    [adUnitIds.rewardedVideo]: {
        name: 'RV',
        key: 'rewardedVideo',
        icon: 'rewardedVideoIcon',
        displayName: 'Rewarded Video'
    },
    [adUnitIds.interstitial]: {
        name: 'IS',
        key: 'interstitial',
        icon: 'interstitialIcon',
        displayName: 'Interstitial'
    },
    [adUnitIds.offerwall]: {
        name: 'OW',
        key: 'offerWall',
        icon: 'offerWallIcon',
        displayName: 'Offerwall'
    },
    [adUnitIds.banner]: {
        name: 'BN',
        key: 'banner',
        icon: 'bannerIcon',
        displayName: 'Banner'
    }
};

export default {
    adUnitIds,
    adUnitsMap
};
